var _defs, _polygon, _polygon2, _g, _g2, _circle, _circle2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .g {\n        fill: none;\n        stroke: #6ebe44;\n        stroke-width: .75px;\n      }\n\n      .g, .h {\n        stroke-miterlimit: 10;\n      }\n\n      .i {\n        fill: url(#e);\n      }\n\n      .i, .j, .k, .l, .m, .n, .o {\n        stroke-width: 0px;\n      }\n\n      .h {\n        fill: url(#b);\n        stroke: url(#c);\n        stroke-width: .5px;\n      }\n\n      .j {\n        fill: #fff;\n      }\n\n      .k {\n        fill: #193319;\n      }\n\n      .l {\n        fill: url(#d);\n      }\n\n      .m {\n        fill: #5bc658;\n      }\n\n      .p {\n        opacity: .3;\n      }\n\n      .n {\n        fill: url(#f);\n      }\n\n      .o {\n        fill: #529e26;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 6.2,
    y1: 0.13,
    x2: 50.64,
    y2: 55.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#013601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#054007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0c5010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#16661c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#23832d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#32a641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39b54a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.74,
    y1: 30,
    x2: 59.26,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#143214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3c853a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5bc658"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 25.77,
    cy: 16.19,
    fx: 25.77,
    fy: 16.19,
    r: 27.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7ff3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00553f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 25.77,
    cy: 16.19,
    fx: 25.77,
    fy: 16.19,
    r: 27.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb43f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffaa3f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 25.77,
    cy: 16.19,
    fx: 25.77,
    fy: 16.19,
    r: 27.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc53f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53db3f"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "o",
    points: "56.56 42.23 53.62 45.49 51.77 49.48 48 51.73 45.06 54.99 40.79 56.03 37.02 58.28 32.64 58.01 28.37 59.05 24.26 57.5 19.88 57.24 16.41 54.55 12.29 53.01 9.77 49.41 6.3 46.72 4.94 42.55 2.42 38.95 2.35 34.56 1 30.39 2.23 26.17 2.17 21.78 4.59 18.12 5.83 13.9 9.22 11.12 11.64 7.45 15.71 5.79 19.1 3 23.47 2.61 27.54 .95 31.83 1.87 36.21 1.47 40.04 3.62 44.34 4.53 47.37 7.71 51.2 9.85 53.16 13.78 56.2 16.95 56.91 21.29 58.88 25.21 58.28 29.57 59 33.9 57.15 37.88 56.56 42.23"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "56.56 42.23 53.62 45.49 51.77 49.48 48 51.73 45.06 54.99 40.79 56.03 37.02 58.28 32.64 58.01 28.37 59.05 24.26 57.5 19.88 57.24 16.41 54.55 12.29 53.01 9.77 49.41 6.3 46.72 4.94 42.55 2.42 38.95 2.35 34.56 1 30.39 2.23 26.17 2.17 21.78 4.59 18.12 5.83 13.9 9.22 11.12 11.64 7.45 15.71 5.79 19.1 3 23.47 2.61 27.54 .95 31.83 1.87 36.21 1.47 40.04 3.62 44.34 4.53 47.37 7.71 51.2 9.85 53.16 13.78 56.2 16.95 56.91 21.29 58.88 25.21 58.28 29.57 59 33.9 57.15 37.88 56.56 42.23"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m6.24,23l-.86-.29.56-1.66,5.07,1.73-.34.99-4.21-1.43-.23.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m11.36,16.45c.98.59,2.15,1.89,1.41,3.1-.74,1.21-2.42.77-3.4.18-.98-.6-2.17-1.88-1.42-3.11.75-1.23,2.43-.77,3.41-.17Zm-1.47,2.4c.46.28,1.72.86,2.1.23.39-.64-.72-1.49-1.17-1.76-.46-.28-1.71-.86-2.09-.22-.38.63.7,1.47,1.16,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m14.73,12.75c.83.79,1.69,2.3.7,3.33s-2.53.23-3.36-.56c-.83-.8-1.71-2.3-.71-3.34.99-1.04,2.54-.23,3.37.57Zm-1.96,2.02c.38.37,1.49,1.21,2,.68.52-.54-.38-1.6-.77-1.97-.39-.37-1.48-1.21-1.99-.67-.51.53.37,1.59.75,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m16.86,9.3c.39.62.21,1.36-.41,1.75-.62.39-1.36.22-1.75-.4-.39-.63-.21-1.37.4-1.75s1.36-.22,1.75.4Zm-1.56.98c.17.28.55.47.85.28s.29-.61.12-.88c-.17-.28-.55-.48-.85-.29s-.29.61-.11.89Zm2.54-2.86l.5,6.19-.55.05-.49-6.19.54-.05Zm3.09,2.99c.39.62.21,1.36-.41,1.75-.62.39-1.36.22-1.75-.4-.39-.63-.21-1.37.4-1.75s1.36-.22,1.75.4Zm-1.56.98c.17.28.55.47.85.28s.29-.61.12-.88c-.17-.28-.55-.48-.85-.29s-.29.61-.11.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m26.93,10.08c-1.61.25-2.81-.84-3.04-2.4-.24-1.57.62-2.94,2.2-3.18s2.8.81,3.04,2.38c.24,1.56-.58,2.95-2.19,3.19Zm-.69-4.56c-.98.15-1.42,1.1-1.29,1.96.12.81.68,1.76,1.83,1.58,1.14-.17,1.4-1.24,1.27-2.05-.13-.86-.84-1.63-1.81-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m33.92,9.98l-1.26-.12-1.09-2.27h-.01s-.2,2.15-.2,2.15l-1.04-.1.49-5.33,1.41.13c1.05.1,1.74.63,1.63,1.77-.06.68-.5,1.32-1.22,1.38l1.3,2.39Zm-2.3-3.11h.13c.57.07.99-.07,1.05-.72.06-.66-.34-.82-.89-.87h-.14s-.15,1.59-.15,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m39.97,8.96l-.04.13c-.5,1.43-1.67,2.44-3.24,1.89-1.47-.51-1.97-2.08-1.48-3.48.5-1.44,1.89-2.35,3.4-1.82.86.3,1.46,1,1.58,1.9l-1.03.17c-.04-.53-.35-1.02-.87-1.21-.95-.33-1.76.48-2.05,1.31s-.14,1.93.81,2.27c.62.21,1.32-.14,1.55-.74l-1.07-.37.28-.8,2.18.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m41.24,11.74l-1,.69-.91-.62,4.81-3.38.67.45-1.4,5.69-.92-.63.29-1.17-1.54-1.04Zm2.31-1.81h-.01s-1.58,1.27-1.58,1.27l1.05.71.54-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m48.01,11.4l.49.57-.99,4.58h0s2.72-2.34,2.72-2.34l.68.79-4.13,3.57-.49-.57.99-4.58h0s-2.75,2.36-2.75,2.36l-.68-.79,4.16-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m47.89,20.41l-.52-.91,4.65-2.66.52.91-4.65,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m53.38,23.39c.23-.4.28-.88.13-1.3-.34-.94-1.41-1.16-2.28-.85-.85.31-1.49,1.18-1.15,2.09.15.42.53.76.94.92l-1.17.43c-.31-.3-.57-.62-.72-1.03-.52-1.41.32-2.91,1.71-3.42,1.43-.52,3.06.02,3.6,1.5.14.39.18.82.12,1.23l-1.17.43Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m4.78,38.54l-.35-.98,5.04-1.81.48,1.34c.38,1.06.2,1.89-.94,2.3-1.07.38-1.8-.01-2.17-1.04l-.17-.49-1.88.68Zm2.7-.97l.07.2c.21.58.45.85,1.1.62.65-.23.61-.64.41-1.19l-.06-.17-1.52.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m10.79,39.35l.54.89-2.56,1.56c-.56.34-1.33.88-.87,1.63.46.76,1.28.32,1.85-.02l2.56-1.56.54.89-2.73,1.67c-1.11.68-2.24.72-2.99-.5s-.19-2.21.92-2.89l2.73-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m12,49.71l-.87-.92.68-2.43h0s-1.57,1.47-1.57,1.47l-.72-.76,3.9-3.67.97,1.03c.73.77.88,1.62.05,2.41-.5.47-1.25.66-1.83.22l-.61,2.65Zm.34-3.86l.09.1c.39.42.8.6,1.27.15.48-.45.29-.84-.09-1.25l-.1-.1-1.17,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m16.61,47.67l-.7.95,1.34.99-.54.73-1.34-.99-.86,1.17,1.39,1.02-.54.73-2.23-1.64,3.18-4.31,2.23,1.64-.54.73-1.39-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m22.59,55.02c-.54.23-1.1.36-1.67.17-.86-.28-1.28-1.12-1-1.98.19-.57.61-.92,1.17-1.08l.37-.11c-.13-.41-.19-.8-.06-1.22.25-.75.98-1.07,1.71-.83.74.24,1.14.92.89,1.68-.18.56-.72.81-1.24.95l.41,1.14.73-.49.43.79-.79.55.49,1.45-1.21-.4-.24-.65Zm-.8-2.19c-.34.11-.72.26-.84.63-.11.32.04.77.38.88.31.1.62-.06.9-.19l-.44-1.32Zm.71-.95l.22-.09c.22-.09.39-.22.47-.46.08-.24.03-.54-.23-.63-.27-.09-.49.09-.57.33-.04.13-.05.28,0,.42l.13.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m28.44,51.19l.75-.03,2.95,3.64h.01l-.12-3.6,1.04-.04.19,5.46-.75.03-2.95-3.64h-.01s.12,3.63.12,3.63l-1.04.04-.19-5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m36.05,54.78l-.12,1.21-1.06.3.52-5.86.78-.22,3.44,4.74-1.07.3-.7-.98-1.79.5Zm.11-2.94h-.01s-.04,2.04-.04,2.04l1.22-.34-1.17-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m41.96,53.79l-.94.45-1.92-4.01-.97.47-.39-.82,2.89-1.38.39.82-.97.47,1.92,4.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m41.04,48.28l.84-.62,1.78,2.41c.39.53.99,1.25,1.71.72s.21-1.31-.19-1.84l-1.78-2.41.84-.62,1.91,2.57c.78,1.05.92,2.17-.23,3.03-1.15.85-2.19.39-2.96-.66l-1.91-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m51.26,46.14l-.84.95-2.48-.46h0s1.61,1.44,1.61,1.44l-.69.78-4-3.55.94-1.06c.7-.79,1.54-1.03,2.39-.27.51.45.77,1.19.38,1.8l2.69.37Zm-3.87,0l.09-.1c.38-.43.52-.85.04-1.28-.49-.44-.87-.21-1.24.2l-.09.11,1.21,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m51.72,43.37l.77.94-.54.96-3.75-4.53.4-.7,5.79.95-.55.97-1.19-.2-.92,1.62Zm-1.99-2.17h0s1.4,1.49,1.4,1.49l.63-1.11-2.02-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m54.34,38.3l.48-1.4.86.29-.81,2.39-5.07-1.73.34-.99,4.21,1.43Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 30,
    cy: 30,
    r: 18.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 30,
    cy: 30,
    r: 16.94
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m8.94,30.43c-.16.32-.42.71-.79,1.08-.07.07-.14.13-.21.19-.24.21-.47.37-.66.5-.05.03-.1.07-.15.09s-.09.05-.13.07c-.11.06-.25,0-.27-.13-.01-.08-.02-.18-.04-.3,0-.04,0-.08-.01-.12-.02-.28-.03-.63.02-1,.06-.46.16-.88.37-1.3.52-1.06,1.51-1.7,1.95-1.94.04-.02.08-.03.12-.02.06,0,.13.06.15.15.15.87.07,1.89-.34,2.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m7.26,29.7s-.06-.07-.04-.11c.35-.73.95-1.25,1.39-1.56.04-.03.09-.02.12.02.03.04.02.09-.02.12-.42.3-.99.8-1.33,1.49-.02.04-.07.06-.11.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m8.94,30.43c-.18.38-.5.8-.79,1.08-.07.07-.14.14-.21.2-.24.21-.47.37-.66.5-.05.03-.1.07-.15.09s-.09.05-.13.07c-.11.06-.25,0-.27-.13-.01-.08-.02-.18-.04-.3,0-.04,0-.08-.01-.12h0s.08,0,.12-.02c.19-.11.49-.29.81-.55.41-.34.85-.8,1.14-1.39.4-.82.43-1.71.38-2.3.06,0,.13.06.15.15.12.94.09,1.84-.34,2.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m6.05,29.56c.16.32.29.77.35,1.29,0,.1.02.19.02.29.01.32,0,.6-.03.83,0,.06-.01.12-.02.18s-.02.1-.02.14c-.02.13-.16.19-.27.13-.07-.04-.16-.1-.26-.16-.03-.02-.07-.05-.1-.07-.23-.16-.51-.37-.77-.64-.33-.33-.59-.68-.79-1.1-.5-1.07-.39-2.24-.3-2.73,0-.04.03-.08.06-.1.04-.04.13-.07.21-.02.77.43,1.52,1.13,1.92,1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m4.43,30.43s-.09,0-.11-.04c-.35-.73-.38-1.52-.35-2.05,0-.05.04-.08.09-.08.05,0,.08.04.08.09-.03.51,0,1.27.34,1.97.02.04,0,.09-.04.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m6.05,29.56c.18.38.31.9.35,1.29.01.1.02.19.02.28.01.32,0,.6-.03.83,0,.06-.01.12-.02.18s-.02.1-.02.14c-.02.13-.16.19-.27.13-.07-.04-.16-.1-.26-.16-.03-.02-.07-.04-.1-.07h0s.05-.06.06-.11c.04-.22.08-.56.07-.97,0-.53-.09-1.16-.38-1.76-.39-.82-1.07-1.4-1.56-1.73.05-.04.13-.06.21-.02.81.5,1.5,1.08,1.92,1.96Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m55.45,30.43c-.16.32-.42.71-.79,1.08-.07.07-.14.13-.21.19-.24.21-.47.37-.66.5-.05.03-.1.07-.15.09s-.09.05-.13.07c-.11.06-.25,0-.27-.13-.01-.08-.02-.18-.04-.3,0-.04,0-.08-.01-.12-.02-.28-.03-.63.02-1,.06-.46.16-.88.37-1.3.52-1.06,1.51-1.7,1.95-1.94.04-.02.08-.03.12-.02.06,0,.13.06.15.15.15.87.07,1.89-.34,2.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m53.76,29.7s-.06-.07-.04-.11c.35-.73.95-1.25,1.39-1.56.04-.03.09-.02.12.02.03.04.02.09-.02.12-.42.3-.99.8-1.33,1.49-.02.04-.07.06-.11.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m55.45,30.43c-.18.38-.5.8-.79,1.08-.07.07-.14.14-.21.2-.24.21-.47.37-.66.5-.05.03-.1.07-.15.09s-.09.05-.13.07c-.11.06-.25,0-.27-.13-.01-.08-.02-.18-.04-.3,0-.04,0-.08-.01-.12h0s.08,0,.12-.02c.19-.11.49-.29.81-.55.41-.34.85-.8,1.14-1.39.4-.82.43-1.71.38-2.3.06,0,.13.06.15.15.12.94.09,1.84-.34,2.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m52.56,29.56c.16.32.29.77.35,1.29,0,.1.02.19.02.29.01.32,0,.6-.03.83,0,.06-.01.12-.02.18s-.02.1-.02.14c-.02.13-.16.19-.27.13-.07-.04-.16-.1-.26-.16-.03-.02-.07-.05-.1-.07-.23-.16-.51-.37-.77-.64-.33-.33-.59-.68-.79-1.1-.5-1.07-.39-2.24-.3-2.73,0-.04.03-.08.06-.1.04-.04.13-.07.21-.02.77.43,1.52,1.13,1.92,1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m50.94,30.43s-.09,0-.11-.04c-.35-.73-.38-1.52-.35-2.05,0-.05.04-.08.09-.08.05,0,.08.04.08.09-.03.51,0,1.27.34,1.97.02.04,0,.09-.04.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m52.56,29.56c.18.38.31.9.35,1.29.01.1.02.19.02.28.01.32,0,.6-.03.83,0,.06-.01.12-.02.18s-.02.1-.02.14c-.02.13-.16.19-.27.13-.07-.04-.16-.1-.26-.16-.03-.02-.07-.04-.1-.07h0s.05-.06.06-.11c.04-.22.08-.56.07-.97,0-.53-.09-1.16-.38-1.76-.39-.82-1.07-1.4-1.56-1.73.05-.04.13-.06.21-.02.81.5,1.5,1.08,1.92,1.96Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m23.31,26.86c-1.4,2.17-1.88,4.92-1.08,7.58,1.34,4.46,5.62,5.92,7.49,6.35-1.63-6.05-5.14-8.38-5.14-8.38,4.56,2.46,6.03,8.55,6.03,8.55,1.99-8.27-6.07-10.04-7.29-14.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m38.37,25.95c1.02,1.52,1.39,3.46.85,5.36-.9,3.18-3.92,4.25-5.23,4.58,1.09-4.31,3.55-5.99,3.55-5.99-3.2,1.79-4.18,6.12-4.18,6.12-1.5-5.83,4.19-7.18,5.01-10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m26.7,22.56c4.76,3.14,5.78,9.96,5.78,9.96,2.99-8.87-5.69-11.6-6.63-16.17-1.75,2.24-2.54,5.21-1.92,8.21.58,2.81,2.26,4.68,3.99,5.9,2.05,1.45,3.41,3.7,3.6,6.21.34,4.3-2.29,6.93-2.29,6.93,5.73-4.1,2.3-11.35,2.3-11.35-1.2-6.8-4.83-9.69-4.83-9.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganic);
export default __webpack_public_path__ + "static/media/organic.e357277a95cb7c3ad7701cc25320976d.svg";
export { ForwardRef as ReactComponent };